import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  imports: [CommonModule, RouterModule, MenuModule, TooltipModule, ButtonModule]
})
export class SideMenuComponent implements OnInit {
  isCollapsed: boolean = false;
  @Output() collapsedChange = new EventEmitter<boolean>();
  private readonly STORAGE_KEY = 'sideMenuCollapsed';

  menuItems: MenuItem[] = [
    {
      label: 'Dashboard',
      icon: 'pi pi-home',
      routerLink: '/dashboard',
      styleClass: 'menu-item-dashboard'
    },
    {
      label: 'Campaigns',
      icon: 'pi pi-megaphone',
      routerLink: '/campaigns',
      styleClass: 'menu-item-campaigns'
    },
    {
      label: 'Insights',
      icon: 'pi pi-chart-bar',
      routerLink: '/insights',
      styleClass: 'menu-item-insights'
    },
    {
      label: 'Profile',
      icon: 'pi pi-user',
      routerLink: '/profile',
      styleClass: 'menu-item-profile'
    }
  ];

  ngOnInit() {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    this.isCollapsed = stored === 'true';
    this.collapsedChange.emit(this.isCollapsed);
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    localStorage.setItem(this.STORAGE_KEY, String(this.isCollapsed));
    this.collapsedChange.emit(this.isCollapsed);
  }
}
